import { Button } from '@cms/components/data/Button'
import { PreviewPublishedIcon } from '@cms/components/icons'
import { generateStoryLink } from '@cms/utils/helpers'
import { useAppSelector } from '@cms/utils/store/hooks'
import { WORKFLOWS } from '@dl/declarations'
import { useMemo } from 'react'

export const PreviewPublishedButton = () => {
    const { story } = useAppSelector((state) => state.editor)

    const buttonState = useMemo(() => {
        if (story?.story_workflow !== WORKFLOWS.Published) {
            return {
                type: 'disabled',
                tooltip: 'You need to publish the story first to go to live story'
            }
        }

        return {
            type: 'enabled',
            tooltip: 'Go to live story'
        }
    }, [story])

    return (
        <Button
            as='link'
            to={generateStoryLink(story, true)}
            target='_blank'
            shape='square'
            tooltip={buttonState?.tooltip}
            inputVariant='gray_text_white_bg'
            disabled={buttonState?.type === 'disabled'}
        >
            <PreviewPublishedIcon width="24" height="24" />
        </Button>
    )
}
